module.exports = __webpack_public_path__ + "img/066-chad.0076d0af.svg";